import React from "react";
import Button from "../";
import cx from "../../../utils/cx";
import s from "./index.css";

const equalRatio = size => (size ? { height: size, width: size } : {});

export default ({ active, className, size, style, ...props }) => (
  <Button
    className={cx({
      [s.round]: true,
      [s.roundActive]: active,
      [className]: className
    })}
    style={{ ...style, ...equalRatio(size) }}
    hoverClassName={s.roundHover}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/Buttons/Round/index.js